import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CaseNextLink = ({ next }) => {
  if (!next) return null;
  return (
    <Link
      to={`/case/${next.slug}`}
      data-testid="case-next"
      className="col-span-12 md:col-span-6 md:col-start-7 group block hairline-l border-l md:pl-10 pl-0 md:border-l"
    >
      <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-3 flex items-center gap-2">
        Next case <ArrowRight className="w-3 h-3" strokeWidth={1.5} />
      </div>
      <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-70 mb-2">
        {next.brand}
      </div>
      <h3 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95] group-hover:opacity-60 transition-opacity">
        {next.title}
        <span className="text-[var(--accent)]">.</span>
      </h3>
      <p className="mt-4 text-base md:text-lg text-[var(--muted)] max-w-prose">
        &ldquo;{next.tagline}&rdquo;
      </p>
    </Link>
  );
};
